import { Redirect, useIsFocused, useLocalSearchParams, type UnknownOutputParams } from 'expo-router'
import { Activity } from 'react'

import { EVENT_ORIGIN } from '@/src/features/community/models/community.constants'
import { CommunityScreen } from '@/src/features/community/ui/screens/CommunityScreen'
import type { TEventOriginParam, TSourceParam } from '@/src/general/constants/routes'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { parseIdDash } from '@/src/general/utils/parseIdDash'
import { useRoutes } from '@/src/general/utils/routes'

type TCommunityPageParams = TIdSlugParam &
  TUpdateParametersTokenParam &
  TSourceParam &
  TEventOriginParam &
  TActionParams &
  UnknownOutputParams

const CommunityRouterPage = () => {
  const isFocused = useIsFocused()
  const searchParams = useLocalSearchParams<TCommunityPageParams>()
  const { idSlug, action, source, updateParametersToken, origin = EVENT_ORIGIN.UNDEFINED } = searchParams

  const { routes } = useRoutes()

  if (!idSlug) return

  const [id, slug] = idSlug ? parseIdDash(idSlug) : []

  if (!id || !slug) return <Redirect href={routes.communities()} />

  if (action?.includes('show-notifications')) {
    return <Redirect href={routes.communityNotifications({ id, slug, updateParametersToken })} />
  }

  if (action?.includes('join')) {
    return (
      <Redirect
        href={routes.communityJoin({
          id,
          slug,
          source: source || TRACKING_SOURCE.EMAIL_LINK,
          origin: EVENT_ORIGIN.AUTOMATIC,
          course: 'direct',
        })}
      />
    )
  }

  return (
    <Activity mode={isFocused ? 'visible' : 'hidden'}>
      <CommunityScreen id={id} action={action} origin={origin} slug={slug} searchParams={searchParams} />
    </Activity>
  )
}

export default CommunityRouterPage
